// extracted by mini-css-extract-plugin
export var button = "_eg-4";
export var hasDarkBackground = "_eg-7";
export var hasLightBackground = "_eg-6";
export var iconWrapper = "_eg-0";
export var large = "_eg-2";
export var medium = "_eg-1";
export var small = "_eg-5";
export var xsmall = "_eg-3";